<template>
  <div class="i-test-retake">
    <iNavbarSimple />

    <div v-show="isQuizStarted">
      <div class="container-qubl">
        <iQublQuizRetake
          ref="qublQuiz"
          :quiz-id="GlobalFunctions.getQublQuizId()"
          :quiz-style="GlobalFunctions.getQublStyle()"
          @quiz-completed="onQuizCompleted"
          @quiz-error="onQuizError"
        />
      </div>
    </div>

    <div v-if="isQuizError">
      <div class="container-error-general">
        <iBaseErrorCard
          button-text="Back to Package"
          :error-message-one-h-t-m-l="data.quizErrorMessageHTML"
          @clicked-logo="goToReportWithReload()"
          @clicked-button="goToReportWithReload()"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useExitModal } from "@/composables/useExitModal"
import { useReportStore } from "@/stores/report"
import { computed, reactive, ref } from "vue"
import { useRouter } from "vue-router"

import { GlobalFunctions } from "@/helpers/globalFunctions"
import { GlobalVariables } from "@/helpers/globalVariables"
import QuizService from "@/services/quizService"

import iBaseErrorCard from "@/components/base/BaseErrorCard.vue"
import iNavbarSimple from "@/components/global/NavbarSimple.vue"

import iQublQuizRetake from "@/views/jobTest/sections/QublQuizRetake.vue"

// TYPES
import type { ApiError } from "@/shared/apiClient"

// ROUTER
const router = useRouter()

// STORES
const reportStore = useReportStore()

// COMPOSABLES
const { removeExitModal } = useExitModal()

// REFS
const qublQuiz = ref(null)

// DATA
const data = reactive({
  loadingAnimationDurationMs: 4000,
  quizStatus: QuizService.QUIZ_STATUSES.STARTED,
  quizErrorMessageHTML: QuizService.ERROR_MESSAGES["DEFAULT"]
})

// COMPUTED
const isQuizStarted = computed(() => {
  return data.quizStatus === QuizService.QUIZ_STATUSES.STARTED
})

const isQuizError = computed(() => {
  return data.quizStatus === QuizService.QUIZ_STATUSES.ERROR
})

// FUNCTIONS
function goToReportWithReload() {
  // Do not use native Vue router push method because it won't trigger a page reload
  const protocol = window.location.protocol
  const baseUrl = `${protocol}//${window.location.host}`
  const pageUrl = GlobalVariables.urls.report.path
  GlobalFunctions.redirectToPage({ baseUrl, pageUrl, queryUrl: "" })
}

function goToReport() {
  router.push({ name: GlobalVariables.urls.report.routeName })
}

function onQuizCompleted() {
  data.quizStatus = QuizService.QUIZ_STATUSES.COMPLETED
  removeExitModal()
  reportStore.triggerLoading(goToReport)
}

function onQuizError(error: ApiError) {
  if (error.status === 400) data.quizErrorMessageHTML = QuizService.ERROR_MESSAGES[400]
  else if (error.status === 401) data.quizErrorMessageHTML = QuizService.ERROR_MESSAGES[401]
  else if (error.status === 403) data.quizErrorMessageHTML = QuizService.ERROR_MESSAGES[403]
  else if (error.status === 500) data.quizErrorMessageHTML = QuizService.ERROR_MESSAGES[500]
  else data.quizErrorMessageHTML = QuizService.ERROR_MESSAGES["DEFAULT"]

  data.quizStatus = QuizService.QUIZ_STATUSES.ERROR
}
</script>

<style scoped lang="scss">
.i-test-retake {
  .container-qubl,
  .container-loader,
  .container-error-email,
  .container-error-general {
    height: calc(100vh - 90px);
    margin-left: auto;
    margin-right: auto;
    width: 90%;
  }

  .container-qubl {
    margin-top: 10px;
    max-width: $section-max-width;
  }

  .container-loader {
    margin-top: -60px;
    max-width: $section-max-width;
  }

  .container-error-general {
    @include flex($justify: center, $align: center);

    max-width: 450px;
    margin-top: -30px;
  }
}
</style>
